import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Space, Table, Image, Flex, Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';

import projectApi from '../../api/project';
import SH_Toolbar from '../../components/SH_Toolbar';
import TV_project_detail from './TV_project_detail';
import pagesApi from '../../api/page';

const { Title } = Typography;

const TV_project = () => {
	const [dictionary, setDictionary] = useState({ categories: [] });
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [total, setTotal] = useState(0);
	const refDetail = useRef();

	const [filter, setFilter] = useState({
		page: 1,
		limit: 10,
		search: '',
	});

	useEffect(() => {
		getProducts();
		getCategory().then((r) => r);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCategory = async () => {
		setLoading(true);
		try {
			const [categories] = await Promise.all([
				pagesApi.get({
					page: 1,
					limit: 9999,
				}),
			]);

			setDictionary({
				categories: categories?.data?.data?.items?.map((x) => ({ ...x, label: x?.names?.vi })) || [],
			});
		} finally {
			setLoading(false);
		}
	};

	// GIỮ LOGIC: vẫn dùng filter state như code cũ (không thay)
	const getProducts = (_filter) => {
		setLoading(true);
		projectApi
			.get({
				...filter,
				page: _filter?.page || 1,
				limit: _filter?.limit || 10,
			})
			.then((res) => {
				setProducts(res?.data?.data?.items || []);
				setTotal(res?.data?.data?.pagination?.total || 0);
				setLoading(false);
			});
	};

	const conFirm = (event) => {
		return Modal.confirm({
			title: 'Xác nhận xóa',
			content: 'Bạn có chắc chắn muốn xóa bản ghi này không ? ',
			onOk: () => {
				deleteItem(event);
			},
			footer: (_, { OkBtn, CancelBtn }) => (
				<>
					<CancelBtn />
					<OkBtn />
				</>
			),
			okText: 'Xóa',
			cancelText: 'Hủy',
			okButtonProps: { danger: true },
		});
	};

	const deleteItem = (event) => {
		setLoading(true);
		projectApi.delete(event._id).then(() => {
			setLoading(false);
			getProducts();
		});
	};

	const showModal = () => {
		refDetail.current.create();
	};
	const handlePageChange = (page, pageSize) => {
		setFilter((prevState) => ({ ...prevState, page, limit: pageSize }));
		getProducts({ ...filter, page, limit: pageSize });
	};

	const columns = [
		{
			title: 'Ảnh dự án',
			dataIndex: 'image',
			key: 'image',
			width: 120,
			render: (image) =>
				image?.url ? (
					<Image
						width={90}
						height={60}
						style={{ objectFit: 'cover', borderRadius: 10 }}
						src={image.url}
						alt=""
						preview
					/>
				) : (
					<span>-</span>
				),
		},
		{
			title: 'Tên dự án (VI)',
			dataIndex: 'names',
			key: 'names_vi',
			ellipsis: true,
			render: (text) => <span>{text?.vi}</span>,
		},
		{
			title: 'Tên dự án (EN)',
			dataIndex: 'names',
			key: 'names_en',
			ellipsis: true,
			render: (text) => <span>{text?.en}</span>,
		},
		{
			title: 'Ngày tạo',
			dataIndex: 'createdAt',
			key: 'createdAt',
			width: 190,
			render: (createdAt) => <span>{createdAt ? dayjs(createdAt).format('HH:mm A DD/MM/YYYY') : ''}</span>,
			sorter: (a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf(),
			sortDirections: ['descend', 'ascend'],
		},
		{
			title: 'Thao tác',
			key: 'action',
			width: 190,
			render: (_, record) => (
				<Space size="middle">
					<Button onClick={() => refDetail.current.update(record)} icon={<EditOutlined />}>
						Sửa
					</Button>
					<Button onClick={() => conFirm(record)} type="dashed" danger icon={<DeleteOutlined />}>
						Xoá
					</Button>
				</Space>
			),
		},
	];

	return (
		<>
			<Flex
				align="center"
				justify="space-between"
				wrap="wrap"
				gap={12}
				style={{
					marginBottom: 12,
				}}
			>
				<Title level={2} style={{ margin: 0 }}>
					Dự án
				</Title>
			</Flex>

			<SH_Toolbar
				left={() => (
					<Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
						Thêm dự án
					</Button>
				)}
				right={() => (
					<Input.Search
						allowClear
						style={{ width: 260 }}
						placeholder="Nhập tên dự án"
						onChange={(e) => {
							getProducts({
								...filter,
								search: e.target.value,
							});
							setFilter((prevState) => ({ ...prevState, search: e.target.value }));
						}}
					/>
				)}
			/>

			<Table
				rowKey={(record) => record?._id}
				pagination={{
					current: filter.page,
					pageSize: filter.limit,
					total: total,
					onChange: handlePageChange,
					showSizeChanger: true,
				}}
				className="mt-2"
				loading={loading}
				columns={columns}
				dataSource={products}
				scroll={{ x: 1300 }}
			/>

			<TV_project_detail
				ref={refDetail}
				getProducts={getProducts}
				categories={dictionary?.categories}
				colors={dictionary.colors}
			/>
		</>
	);
};

export default TV_project;
